
const custom_links = [
  //comment this section out if you don't want the additional demo links to be shown
  {
      type: "menu-dropdown",
      iconName: "lock-private",
      text: "Healthcare Life Sciences",
      items: [
        {
          id: "content-group",
          text: "Additional Content",
          items: [
            {
              text: "Model molecular SMILES data with Amazon Neptune and RDKit (Blog)",
              href: "https://aws.amazon.com/blogs/database/model-molecular-smiles-data-with-amazon-neptune-and-rdkit/",
              external: true,
              externalIconAriaLabel: "(opens in a new tab)"
            },
            {
              text: "Analyze healthcare FHIR data with Amazon Neptune (Blog)",
              href: "https://aws.amazon.com/blogs/database/analyze-healthcare-fhir-data-with-amazon-neptune/",
              external: true,
              externalIconAriaLabel: "(opens in a new tab)"
            },
            {
              text: "Building a biological knowledge graph at Pendulum using Amazon Neptune",
              href: "https://aws.amazon.com/blogs/database/building-a-biological-knowledge-graph-at-pendulum-using-amazon-neptune/",
              external: true,
              externalIconAriaLabel: "(opens in a new tab)"
            }
          ]
        },
        {
          id: "learning-more-group",
          text: "Learning Material",
          items: [
            {
              text: "Amazon Neptune Analytics",
              href: "https://docs.aws.amazon.com/neptune-analytics/latest/userguide/what-is-neptune-analytics.html",
              external: true,
              externalIconAriaLabel: "(opens in a new tab)"
            },
            {
              text: "Vector-similarity search (VSS) algorithms",
              href: "https://docs.aws.amazon.com/neptune-analytics/latest/userguide/vss-algorithms.html",
              external: true,
              externalIconAriaLabel: "(opens in a new tab)"
            }
          ]
        }
      ]
  }
]

const core_links =  [
  {
    text: "Neptune Snackables",
    href: "https://www.youtube.com/playlist?list=PLhr1KZpdzukfS8UlzkdZFzn86t90hUT6i",
    iconName: "share",
    type: "button",
  }
]

const learner_links = [
  {
        type: "menu-dropdown",
        iconName: "anchor-link",
        text: "Find out more",
        items: [
          {
            id: "content-group",
            text: "Additional Content",
            items: [
              {
                text: "Neptune Samples (GitHub)",
                href: "https://github.com/aws-samples/amazon-neptune-samples",
                external: true,
                externalIconAriaLabel: " (opens in a new tab)"
              },
              {
                text: "Neptune Notebook Samples (GitHub)",
                href: "https://github.com/aws/graph-notebook/tree/main/src/graph_notebook/notebooks",
                external: true,
                externalIconAriaLabel: "(opens in a new tab)"
              },
              {
                text: "Neptune Developer Resources",
                href: "https://aws.amazon.com/neptune/developer-resources/",
                external: true,
                externalIconAriaLabel: " (opens in a new tab)"
              }
            ]
          },
          {
            id: "learning-group",
            text: "Learning Material",

            items: [
              {
                  text: "Data Modeling on Neptune",
                  href: "https://explore.skillbuilder.aws/learn/course/external/view/elearning/16133/data-modeling-for-amazon-neptune",
                  external: true,
                  externalIconAriaLabel: " (opens in a new tab)"
              },
              {
                text: "Case Studies",
                href: "https://aws.amazon.com/solutions/case-studies/?customer-references-cards.sort-by=item.additionalFields.sortDate&customer-references-cards.sort-order=desc&awsf.content-type=*all&awsf.customer-references-location=*all&awsf.customer-references-segment=*all&awsf.customer-references-industry=*all&awsf.customer-references-use-case=*all&awsf.customer-references-tech-category=*all&awsf.customer-references-product=*all&customer-references-cards.q=Neptune&customer-references-cards.q_operator=AND&awsm.page-customer-references-cards=1",
                external: true,
                externalIconAriaLabel:
                    " (opens in new tab)"
              },
            ]
          },
          {
            id: "tools",
            text: "Tools",
            items: [
              {
                text: "Amazon Neptune Tools Hub",
                href: "https://tools.neptunedemos.com",
                external: true,
                externalIconAriaLabel: "(opens in a new tab)"
              },
              {
                text: "Neptune Tools (GitHub)",
                href: "https://github.com/awslabs/amazon-neptune-tools",
                external: true,
                externalIconAriaLabel: " (opens in a new tab)"
              }
            ]
          }
        ]
    }
]

export const navlinks = [...core_links, ...custom_links, ...learner_links]